// // app/translate/translation.ts

import { OpaqueToken } from '@angular/core';

 // import translations
 import { LANG_EN_NAME, LANG_EN_TRANS } from './lang-en';
 import { LANG_ES_NAME, LANG_ES_TRANS } from './lang-es';
 import { LANG_ZH_NAME, LANG_ZH_TRANS } from './lang-zh';

// // translation token
 export const TRANSLATIONS = new OpaqueToken('translations');

// all traslations
export const dictionary = {
	en: LANG_EN_TRANS,
	es: LANG_ES_TRANS,
	zh: LANG_ZH_TRANS,
};

// // providers
 export const TRANSLATION_PROVIDERS = [
 	{ provide: TRANSLATIONS, useValue: dictionary },
 ];


// WEBPACK FOOTER //
// /media/julen/a87ddcee-c364-426b-b833-77926fe0cdef/julen/Ironchip/Proyectos/dative/dative-FMOT/FMOT/src/app/translate/translations.ts